// extracted by mini-css-extract-plugin
export default {"desc":"CostInfo_desc__2RxRl","infoIcon":"CostInfo_infoIcon__j1XMf","mb6":"CostInfo_mb6__bU4eU","mb24":"CostInfo_mb24__JCmm9","noStyleItem":"CostInfo_noStyleItem__V4Ous"};